// extracted by mini-css-extract-plugin
module.exports = {"Screen":"LoginPage_Screen__2qMeE","Form":"LoginPage_Form__10P86","logo":"LoginPage_logo__26H7i","ButtonArea":"LoginPage_ButtonArea__3YnZL"};